const RentRelief = {
  name: 'TO_PASS_GC_VALIDATION',
  property: {
    address: {
      street: undefined,
      suburb: undefined,
      state: undefined,
      postCode: undefined,
    },
    tenant: {
      type: undefined,
      relatedParty: false,
      details: {
        companyName: undefined,
        signee: undefined,
        position: undefined,
        trustName: undefined,
        trusteeName: undefined,
      },
    },
  },
  determination: {
    jobKeeper: undefined,
    turnover: undefined,
    turnoverReduction: undefined,
    relativePeriod: {
      start: '',
      end: '',
    },
    impactedByCovid: undefined,
  },
  adjustments: {
    drivers: {
      closure: {
        hasClosure: undefined,
        date: undefined,
      },
      drivers: [],
      other: '',
    },
    adjustments: {
      adjustments: [],
      other: '',
    },
    reduction: {
      amount: 0,
      startDate: '',
      reviewDate: '',
    },
    waiver: 0,
    deferral: 0,
    deferralDate: '',
    accommodations: {
      hasAccommodations: false,
      accommodations: [],
      other: '',
    },
    landlord: {
      hasLandlord: false,
      landlord: [],
      other: '',
    },
  },
};

export default RentRelief;
